import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["visible", "sticky"];
  observer = null;
  mediaQuery = null;

  connect() {
    this.mediaQuery = window.matchMedia('(max-width: 767px)');
    this.handleViewportChange(this.mediaQuery);

    this.mediaQuery.addEventListener("change", this.handleViewportChange);
  }

  disconnect() {
    if (this.observer && this.visibleTarget) {
      this.observer.unobserve(this.visibleTarget);
    }
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener("change", this.handleViewportChange);
    }
  }

  handleViewportChange = (e) => {
    const isMobileTablet = e.matches;

    if (isMobileTablet) {
      if (!this.observer) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) {
              this.stickyTarget.classList.add("visible");
            } else {
              this.stickyTarget.classList.remove("visible");
            }
          },
          { threshold: 0.95 }
        );
      }

      if (this.visibleTarget) {
        this.observer.observe(this.visibleTarget);
      }
    } else {
      if (this.observer && this.visibleTarget) {
        this.observer.unobserve(this.visibleTarget);
      }
      this.stickyTarget.classList.remove("visible");
    }
  };
}
